<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Funil de oportunidades</div>
                <div class="text text--thin mb-2">Funis ativos para as oportunidades cadastradas no sistema</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        :loading="loading"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <div class="py-2 px-2 table_search_area">
            <v-text-field
              clearable
              hide-details=""
              clear-icon="close"
              v-model="search"
              outlined
              label="Busca"
            ></v-text-field>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogFunil(item)" color="primary" class="mr-2">
                  settings
                </v-icon>
              </template>
              <span>Configurar</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogFunil"
      persistent
      max-width="550px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Etapas do {{funil ? funil.fun_nome : ''}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogFunil()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="content_itens" v-if="loadingEtapas">
          <v-row align="center" justify="space-between" no-gutters v-for="i in 5" :key="i">
            <v-col cols="10">
              <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
            </v-col>
            <v-col cols="2">
              <v-skeleton-loader type="button" class="mb-3"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <div class="content_itens" v-if="!loadingEtapas && !!etapas">
          <draggable tag="ul" :list="etapas" class="pl-0" handle=".handle" @end="checkMove">
            <li
              class="px-1 py-2"
              v-for="(item, index) in etapas"
              :key="index"
            >
              <v-row align="center">
                <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="pt-0">
                  <div class="border_color" :style="'border-color:' + item.fet_cor">
                    <v-row no-gutters align="center" justify="center" class="text--thin">
                      <v-icon class="handle ml-1 cursor-pointer">reorder</v-icon>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="7" lg="7" xl="7" class="pt-0">
                  <div class="text-h3">
                    {{item.fet_nome}}
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0">
                  <v-row no-gutters align="center" justify="end">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                          edit
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                          delete
                        </v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="mt-2 mb-1" v-if="index+1 < etapas.length"></v-divider>
            </li>
          </draggable>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialogFunil()"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            @click="dialogNovo = true"
            :loading="salvando"
            :disabled="salvando"
          >
            Nova etapa
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="450px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{etapa.uuid_fet_id ? 'Editar etapa' : 'Novo etapa'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formEtapas">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <div class="text-h3 mb-3">
                Selecione a cor primária:
              </div>
              <div>
                <v-menu offset-y v-model="openColorPrimary" :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-row no-gutters justify="start">
                      <v-btn :loading="salvando" :disabled="salvando" v-on="on" v-bind="attrs" rounded :style="'background-color:' + etapa.fet_cor" class="height_btn"></v-btn>
                    </v-row>
                  </template>
                  <v-color-picker
                    dot-size="13"
                    hide-inputs
                    hide-mode-switch
                    v-model="etapa.fet_cor"
                  ></v-color-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-text-field
                v-model="etapa.fet_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditEtapa()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Etapa
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelEtapaDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Etapa <b class="text-primary">{{etapa.nome}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="cancelEtapaDelete()"
            :loading="salvando"
            :disabled="salvando"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeEtapa(etapa.uuid_fet_id)"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  data () {
    return {
      user: null,
      loading: false,
      loadingEtapas: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      openColorPrimary: false,
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'fun_id'
        },
        { text: 'Nome', value: 'fun_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      funil: {},
      itens_funil: [
        {
          id: 1,
          nome: 'Nova oportunidade',
          cor: '#CB0808'
        },
        {
          id: 2,
          nome: 'Geração de proposta',
          cor: '#FF5C00'
        },
        {
          id: 3,
          nome: 'Proposta enviada',
          cor: '#DCD300'
        },
        {
          id: 4,
          nome: 'Negociação',
          cor: '#00B01A'
        },
        {
          id: 5,
          nome: 'Fechamento',
          cor: '#004A93'
        }
      ],
      etapas: [],
      dialogFunil: false,
      etapa: {
        fet_nome: '',
        fet_cor: '',
        fet_ordem: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.getFunis()
    },
    checkMove (evt) {
      this.reordenaEtapas()
    },
    async getFunis () {
      this.loading = true
      await Api.get('funis')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.dados = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os funis!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getEtapas () {
      this.loadingEtapas = true
      await Api.get(`funis/etapas/funil/${this.funil.uuid_fun_id}`)
        .then(res => {
          if (res.data) {
            this.etapas = res.data
          }
          this.loadingEtapas = false
        })
        .catch(err => {
          this.loadingEtapas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as etapas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async reordenaEtapas () {
      const novaOrdem = this.etapas.map(item => {
        return {
          uuid_fet_id: item.uuid_fet_id
        }
      })
      await Api.post('funis/etapas/reordenar', novaOrdem)
        .then(res => {
          if (res.data) {
            console.log(res.data)
          }
        })
        .catch(err => {
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao reordenar as etapas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialogFunil (item) {
      this.funil = JSON.parse(JSON.stringify(item))
      this.getEtapas()
      this.dialogFunil = true
    },
    closeDialogFunil () {
      this.funil = {}
      this.dialogFunil = false
    },
    saveEditEtapa () {
      if (!this.$refs.formEtapas.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }

      this.salvando = true
      let endpoint = 'funis/etapas/novo'
      let editado = false
      if (this.etapa.uuid_fet_id) {
        endpoint = 'funis/etapas/edita'
        editado = true
      }

      this.etapa.uuid_fun_id = this.funil.uuid_fun_id
      this.etapa.uuid_int_id = this.user.uuid_int_id
      this.etapa.fet_ordem = this.etapas.length

      Api.post(endpoint, this.etapa)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Etapa atualizada com sucesso!' : 'Etapa cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getEtapas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeEtapa (uuidFetId) {
      this.salvando = true
      Api.delete(`funis/etapas/remove/${uuidFetId}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getEtapas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover etapa!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.etapa = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    cancelEtapaDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    openDialogDelete (item) {
      this.etapa = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    closeDialog () {
      this.etapa = {
        fet_nome: '',
        fet_cor: '',
        fet_ordem: 0
      }
      if (this.$refs.formEtapas) {
        this.$refs.formEtapas.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.content_itens {
  max-height: 350px;
  padding: 5px 15px;
  overflow: auto;
}
.border_color {
  border-left: 5px solid;
  padding-left: 5px;
}
.height_btn {
  height: 60px!important;
  border: 1px $text solid;
  min-width: 60px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Funil.vue